import { Controller } from "stimulus"
import MitreTable from "../utils/mitre-table";


const SELECTED_TAB_STYLES = ['m-table-tabs-tab__active', 'mp-table-tabs-tab__active']

class TabsController extends Controller {
  static targets = [
    'tab'
  ];

  initialize() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    this._defaultTabKey = this.element.getAttribute('data-default-tab-key');
  }

  connect() {
    this._refreshUI();

    this._mitreTable.on('update_collection', () => this.__toggleTabsVisilibity());
  }

  _refreshUI() {
    const { currentTabKey } = this._mitreTable.getParams();
    const tabEl = this._findTabTarget(currentTabKey);
    if (tabEl) {
      this.tabTargets.forEach(el => this._removeTabStyles(el));
      this._addSelectedTabStyles(tabEl);
    }
  }

  switchTab(e) {
    this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.TAB_CHANGE });
    if (MitreTable.areInteractionsLocked()) return;

    const clickedTabTargetEl = e.target.closest('[data-tab-key]');
    const newTabKey = clickedTabTargetEl.getAttribute('data-tab-key');
    this._mitreTable.setParam('currentTabKey', newTabKey);

    this._refreshUI();

    this._mitreTable.emit('table-header-update', { pagination: 'currentPage' });

    this._mitreTable.emit('table-body-update', { pagination: 'currentPage',
      options: {
        ignoreFirstColumn: true
      }
    });

    this._mitreTable.emit('table-sticky-row-update');
    this._mitreTable.emit('table-aggregate-row-update');
  }

  _addSelectedTabStyles(el) {
    el.classList.add(...SELECTED_TAB_STYLES);
  }

  _removeTabStyles(el) {
    el.classList.remove(...SELECTED_TAB_STYLES);
  }

  // Toggle visibility of tabs depending on collection type for Merged SEOTable
  __toggleTabsVisilibity() {
    const { collectionKey } = this._mitreTable.getParams();

    let el = this.element;

    if (el.dataset.tableKey != 'Merged-SEOTable') {
      return;
    }

    let tabs = el.querySelectorAll('[data-collection-visibility]');
    tabs.forEach((tab) => {
      if (tab.dataset.collectionVisibility.includes(collectionKey)) {
        tab.hidden = false;
      } else {
        tab.hidden = true;
      }
    })

    // Switch to/ select default tab if the current one becomes hidden.
    let activeTab = el.querySelector(`.${SELECTED_TAB_STYLES[0]}`);
    if (activeTab.hidden) {
      this._findTabTarget(this._defaultTabKey).click();
    }
  }

  _findTabTarget(tabKey) {
    return this.tabTargets.find(tab => tab.getAttribute('data-tab-key') === tabKey);
  }

  get tableKey() {
    return this.element.getAttribute('data-table-key');
  }
}

export default TabsController;
